'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7(outer) {
  this.bVQ = null;
  this.bVO = null;
  this.bVP = false;
  this.bVM = null;
  this.bVN = false;
  this.bVR = false;
  this.bVS = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bVQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7 as $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7 };
$p = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7;
/** @constructor */
function $h_Lpresto_pages_envelopes_EnvelopesView$$anon$7() {
}
export { $h_Lpresto_pages_envelopes_EnvelopesView$$anon$7 as $h_Lpresto_pages_envelopes_EnvelopesView$$anon$7 };
$h_Lpresto_pages_envelopes_EnvelopesView$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bVQ;
});
$p.t = (function() {
  if ((!this.bVP)) {
    this.bVO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("up", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bVP = true;
  }
  return this.bVO;
});
$p.ag = (function() {
  if ((!this.bVN)) {
    this.bVM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bVN = true;
  }
  return this.bVM;
});
$p.v = (function() {
  if ((!this.bVS)) {
    this.bVR = false;
    this.bVS = true;
  }
  return this.bVR;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_envelopes_EnvelopesView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_envelopes_EnvelopesView$$anon$7, "presto.pages.envelopes.EnvelopesView$$anon$7", ({
  WM: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_envelopes_EnvelopesView$$anon$7 as $d_Lpresto_pages_envelopes_EnvelopesView$$anon$7 };
//# sourceMappingURL=presto.pages.envelopes.-Envelopes-View$$anon$7.js.map
